import { UserAlert } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

export const getUserAlerts = async (): Promise<UserAlert[]> => {
  const { data } = await queryBuilder('GET', 'alerts');
  return data;
};
